import { Icon } from '@apostrophe/ui';
import isEmpty from 'lodash/isEmpty';
import React, {
	useEffect,useState
} from 'react';
import Cookies from 'universal-cookie';

const cookies = new Cookies();

const PromoCode = ({
	state,
	dispatcher,
	isOpen,
	title,
	placeholder,
	hideTitle,
	promoCode,
	setVisitCost,
	setRxCredit,
	rxVisitCreditDisabled,
	medCheckout,
	otcCheckout,
	isFollowupv2,
	isPtPref,
}) => {
	const [promoLocal, setPromo] = useState(promoCode);
	const [fullPromoObject, setFullPromoObject] = useState(promoCode);
	const [rxVisitCreditDisabledFlag, setRxVisitCreditDisabledFlag] = useState(rxVisitCreditDisabled); // AB Test: disable rx credits associated with $20 visit
	const [open, setOpen] = useState(isOpen);
	const [accepted, setAccepted] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [promoTitle, setTitle] = useState(title);
	const promoInput = React.createRef();

	const promoInputText = promoLocal?.length > 0 ? 'Apply' : 'Cancel';

	// If possible, show the actual amount saved instead of the face value of the coupon.
	const totalDiscount = state.cart.promos[state.promo.code]?.applied_credit_cents
		? state.cart.promos[state.promo.code]?.applied_credit_cents / 100
		: state.cart.promos[state.promo.code]?.discount_cents / 100;


	const [errorMessages, setErrorMessages] = useState(
		{
			giftcard: 'Please redeem gift cards at https://app.apostrophe.com/register/giftcard/',
			promo_applied: 'You may only apply one promo per transaction.',
			min_purchase: `This promo code may only be used on orders of $${state.promo.min} or more`,
			not_found: `The code ${state.promo.code} is invalid. Please try again.`,
			conflicting_discount: `Sorry, promo code ${state.promo.code} cannot be combined with other discounts applied to your account.`,
			expired: `Sorry, promo code ${state.promo.code} has expired.`,
			not_eligible: `Sorry, promo code ${state.promo.code} cannot be applied to your account.`,
			invalid_product: `Sorry, promo code ${state.promo.code} is not valid for your cart.`,
			base: `Error applying promo ${state.promo.code} to cart.`,
			eligible_on_visit_only: isPtPref ? 'A free assessment has already been applied to your cart.' : `Sorry, promo code ${state.promo.code} is not eligible for the products in your cart. Please remove the promo code and try again.`,
			not_eligible_on_visit_only: `${state.promo.code} is not valid for doctor visit fees. Apply this promo code later when purchasing your medications.`,
		}
	);
	const [successMessage, setSuccessMessage] = useState(`Promo code ${state.promo.code} added. You saved $${totalDiscount}.`);

	let outterStyles = {}
	let titleStyles = {}
	let buttonStyles = { fontWeight : 600 }
	let addStyles = {}
	let inputStyles = {}
	let wrapperStyles = {}
	let innerInputStyles = {}
	if (medCheckout) {
		outterStyles = {
			marginBottom: open ? '10px' : '0',
			fontSize : '14px',
		}
		titleStyles = {
			color: '#666666',
			marginBottom: '8px',
			fontSize: '16px',
			textDecoration: open ? 'none' : 'underline',
		}
		wrapperStyles = {
			justifyContent: 'flex-start',
			marginBottom: 0,
		}
		// buttonStyles = { height: '30px', fontSize: '15px', padding: '5px' }
		addStyles = {
			marginRight: '5px',
			textDecoration: 'none !important',
		}
		//inputStyles = { height: '30px' }
		innerInputStyles = {
			padding: '5px 20px',
			width: '100%',
		}
	}
	if (otcCheckout) {
		innerInputStyles.padding = '5px';
	}

	useEffect(() => {
		if (setVisitCost) {
			let visitCost = state.cart.visitFeeCents;
			Object.keys(state.cart.promos).forEach((key) => {
				visitCost -= state.cart.promos[key].discount_cents;
			});
			if (visitCost < 0) {
				visitCost = 0;
			}
			if (fullPromoObject && fullPromoObject.rx_credit !== 0) {
				setRxCredit(fullPromoObject.rx_credit);
			} else if (rxVisitCreditDisabledFlag) {
				// AB Test: rx credits from visit are disabled, force to $0
				setRxCredit(0);
			} else {
				setRxCredit(visitCost);
			}
			setVisitCost(visitCost);
		}
	},
	[state.cart.cartTotalCents, fullPromoObject, rxVisitCreditDisabledFlag]);

	const validatePromo = async () => {
		let businessLine = state.businessLine || 'VISIT',
			planID = undefined;
		// somehow  for nothing else is set correctly when triggered from useEffect on page load (when promo code is cookied)...
		if (!state.businessLine && state.type === 'LATISSE') {
			businessLine = 'LASH';
		} else if (!state.businessLine && state.type === 'PREFERENCE') {
			businessLine = 'SKIN';
		} else if (isEmpty(state.cart.products)) {
			businessLine = 'VISIT';
		} else if (state.purchaseableProduct &&
        state.cart.products[state.purchaseableProduct]) {
			businessLine = state.purchaseableProduct;
			planID = state.cart.products[state.purchaseableProduct].plan_id;
		}
		const url = `/ajax/validate_promo/${promoLocal !== '' ? promoLocal : promoCode}/`;
		const Response = await fetch(url,
			{
				method: 'POST',
				credentials: 'include',
				headers: {
					'X-CSRFToken': state.CSRFToken,
				},
				body: JSON.stringify({
					patient_id: state.patientId,
					business_line: businessLine,
					plan_id: planID,
					otcCheckout,
				}),
			});
		return await Response.json()
	};

	const submit = async (ev) => {
		ev.preventDefault();

		if (promoInputText === 'Cancel') {
			setOpen(false);
			return;
		}
		if (!isLoading) {
			setIsLoading(true);
			if (!accepted) {
				const {
					error, success, response,
				} = await validatePromo();
				if (!isEmpty(error)) {
					dispatcher.setPromoData({
						error,
						success,
						code: promoLocal,
					});
				} else {
					applyPromo(response);
					{logAmplitudeEvent('submit_page',
						{ submit_page_actions: 'add_promo_code' })}
					setAccepted(true);
				}
			} else {
				applyPromo({});
				{logAmplitudeEvent('submit_page',
					{ submit_page_actions: 'add_promo_code' })}
			}
			setTimeout(() => setIsLoading(false),
				300);
		}
	};

	const cookieSubmit = async (minPurchase) => {
		const {
			error, success, response,
		} = await validatePromo();
		if (!isEmpty(error)) {
			dispatcher.setPromoData({
				error,
				success,
				code: promoLocal,
			});
		} else {
			if (minPurchase) {
				response.useMin = true;
			}
			applyPromo(response);
			setAccepted(true);
		}
	};

	const toggleOpen = () => {
		setOpen(!open);
		let input = promoInput.current;
		if (input) {
			// Only set focus if promo code input exists (e.g. skip if hidden)
			setTimeout(() => {
				input.focus()
			},
			10)
		}
	};

	const applyPromo = async(response) => {
		if (!accepted || response.useMin) {
			await dispatcher.applyPromoToCart(response);
			setFullPromoObject(response);
			promoCode = response.code;
			state.promo.code = response.code;
			setPromo(response.code);
		} else {
			await dispatcher.removePromoFromCart(response,
				cookies);
			promoCode = '';
			state.promo.code = '';
			setAccepted(false);
		}
	};

	useEffect(() => {
		// clear local promo value when state changes.
		if (!promoCode && accepted) {
			setPromo('');
		}
		if (promoLocal) {
			setErrorMessages({
				giftcard: 'Please redeem gift cards at https://app.apostrophe.com/register/giftcard/',
				promo_applied: 'You may only apply one promo per transaction.',
				min_purchase: `The ${state.promo.code} promo code may only be used on orders of $${state.promo.min ? state.promo.min : state.cart.min_purchase} or more`,
				not_found: `The code you entered ${promoLocal} is invalid. Please try again.`,
				conflicting_discount: `Sorry, promo code ${promoLocal} cannot be combined with other discounts applied to your account.`,
				expired: `Sorry, promo code ${promoLocal} has expired.`,
				not_eligible: `Sorry, promo code ${promoLocal} cannot be applied to your account.`,
				invalid_product: `Sorry, promo code ${promoLocal} is not valid for your cart.`,
				base: `Error applying promo ${promoLocal} to cart.`,
				eligible_on_visit_only: isPtPref ? 'A free assessment has already been applied to your cart.' : `Sorry, promo code ${promoLocal} is not eligible for the products in your cart. Please remove the promo code and try again.`,
				not_eligible_on_visit_only: `${promoLocal} is not valid for doctor visit fees. Apply this promo code later when purchasing your medications.`,
			});
			setSuccessMessage(`Promo code ${promoLocal} added. You saved $${totalDiscount}.`);
		}
		if (state.promo && state.promo.error === 'min_purchase') {
			if ((state.cart && (state.cart.cartTotalCents / 100) > state.promo.min)) {
				setAccepted(false);
				setPromo(state.promo.code);
				cookieSubmit('min_purchase');
			}
		}
		if (state.promo && state.promo.success && !state.cart.promos[state.promo.code]) {
			state.promo = { error: 'min_purchase' };
			setAccepted(false);
		}
	},
	[state.promo, state.cart.cartTotalCents]);

	useEffect(() => {
		if (promoCode) {
			setPromo(promoCode);
			toggleOpen();
			cookieSubmit();
		}
	},
	[]);
	if (accepted) {
		innerInputStyles.fontWeight = '600';
		innerInputStyles.color = '#006368';
	}
	return (
		<div style={outterStyles} className={`page-content promo-code ${open ? 'open' : 'closed'}`}>
			{!hideTitle &&
        <div className="promo-code__title" onClick={toggleOpen} style={wrapperStyles}>
        	<div
        		style={titleStyles}
        		role='button'
        		tabIndex='0'
        		aria-label='add promo code'
        	>
        		{medCheckout ? 'Add Promo Code' : promoTitle}
        	</div>
        	{!medCheckout && <div className="icon">
        	</div>}
        </div>
			}
			<form className="promo-code__form" onSubmit={submit}>
				<div className="promo-code__input-wrapper" style={inputStyles} hidden >
					<input
						className="promo-code__input"
						placeholder={placeholder}
						autoFocus
						onChange={(ev) => setPromo(ev.target.value.toUpperCase())}
						value={promoLocal || ''}
						ref={promoInput}
						style={innerInputStyles}
					/>
					<button type="submit" style={buttonStyles}>{accepted ? 'Remove' : promoInputText}</button>
				</div>
				{state.promo.error &&
          <div className='error msg' style={{
          	display: 'flex',
          	color: '#C8483D',
          }}>
          	<div style={{ margin: '4px 9px 0 0' }}>
          		<Icon name='alert-circle' size='s' />
          	</div>
          	{ errorMessages[state.promo.error] || errorMessages.base }
          </div>
				}
				{state.promo.success &&
          <div className='success msg' style={{
          	display: 'flex',
          	marginTop: '6px',
          	color: '#006368',
          }}>
          	<div style={{ margin: '4px 9px 0 0' }}>
          		<Icon name='check-circle-filled' size='s' />
          	</div>
          	{ successMessage }
          </div>
				}
			</form>
		</div>
	)
};

PromoCode.defaultProps = {
	state: {},
	dispatcher: {},
	title: 'Add promo code',
	isOpen: false,
	placeholder: '',
	rxVisitCreditDisabled: false,
};

export default PromoCode;
